<template>
  <v-container>
    <!-- Page -->
    <h2>Company Data</h2>
    <v-card>
      <v-tabs background-color="white" color="primary" left @change="changeActiveTab($event)">
        <v-tab>Active Client</v-tab>
        <v-tab>Inactive Client</v-tab>
        
        <v-tab-item>
          <v-container fluid class="pb-0 pl-0 pr-0">
            <CompanyActiveClient v-if="tabActive == 0"></CompanyActiveClient>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid class="pb-0 pl-0 pr-0">
            <CompanyNonActiveClient v-if="tabActive == 1"></CompanyNonActiveClient>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-card>

  </v-container>
</template>
<script>

import CompanyActiveClient from './CompanyActiveClient'
import CompanyNonActiveClient from './CompanyNonActiveClient'
export default {
  name: "company-data",
  data() {
    return {
      
      tabActive: 0,
    };
  },
  methods: {
    changeActiveTab(e) {
      this.tabActive = e
    },
    
  },
  created() {
  },
  components: {
    CompanyActiveClient,
    CompanyNonActiveClient,
  }
};
</script>